exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".react-tree .rc-tree li span.rc-tree-switcher {\n  background-image: none; }\n\n.react-tree .rc-tree li span.rc-tree-switcher_open:before {\n  font-family: FontAwesome;\n  content: \"\\F060\";\n  position: absolute; }\n\n.react-tree .rc-tree li span.rc-tree-switcher_close:before {\n  font-family: FontAwesome;\n  content: \"\\F061\";\n  position: absolute; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/postcss-loader/lib?{}!./node_modules/sass-loader/lib/loader.js!./src/tree/tree.component.scss
// module id = 299
// module chunks = 0